module.exports = __webpack_public_path__ + "static/media/process-img.b257858d.png";